const replaceAtIndex = (arr: any[], index: number, newValue: any) => {
  return arr.slice(0, index).concat([newValue]).concat(arr.slice(index + 1, arr.length));
};

export {
  replaceAtIndex
}